// @flow

export const DEVICES = [
  { value: 'mobile', label: 'mobile' },
  { value: 'desktop', label: 'desktop' },
  { value: 'any', label: 'any' }]
